import { render } from "./Nep11TokensTable.vue?vue&type=template&id=5d07542e"
import script from "./Nep11TokensTable.vue?vue&type=script&lang=js"
export * from "./Nep11TokensTable.vue?vue&type=script&lang=js"

import "./Nep11TokensTable.vue?vue&type=style&index=0&id=5d07542e&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__